import { FC } from "react";
import { useGetUser } from "../../../hooks/useGetUser";
import { TPERMISSION_NAMES } from "../../../lib/types/role-management";

interface IProps {
  children: JSX.Element;
  accessLevels: TPERMISSION_NAMES[];
}

const RoleBased: FC<IProps> = ({ children, accessLevels }) => {
  const { canUser } = useGetUser();
  const isUserPermitted = canUser(accessLevels);

  if (!isUserPermitted) {
    return null;
  }

  return children;
};

export default RoleBased;
